import { apiUrl2 } from '../../../settings'

export const getAllCountryStatusListCountUrl = () => {
  return apiUrl2 + '/api/getAllStatusCount'
}
